module.exports = __webpack_public_path__ + "static/media/star-solid.03987135.svg";